<template>
  <v-slide-group class="main-events mb-2" v-model="group" show-arrows="always">
    <template v-slot:prev>
      <div @click="prev">
        <v-icon
          dense
          class="primary"
          style="border-radius: 2rem; width: 35px; height: 35px;"
        >
          mdi-chevron-left
        </v-icon>
      </div>
    </template>
    <template v-slot:next>
      <div @click="next">
        <v-icon
          dense
          class="primary"
          style="border-radius: 2rem; width: 35px; height: 35px;"
        >
          mdi-chevron-right
        </v-icon>
      </div>
    </template>
    <!-- width: 17.5em; height: 8.75em; -->

    <v-slide-item
      v-for="(event, i) in mainEvents"
      :key="event.id_event"
      v-slot="{ active, toggle }"
      :class="[
        i === 0 ? 'pl-0' : '',
        i + 1 === mainEvents.length ? 'pr-0' : '',
      ]"
    >
      <div class="pa-2" @click="toggle">
        <MainEventCard :event="event" :index="i" />
      </div>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
import MainEventCard from "./MainEventCard.vue";

export default {
  name: "DesktopMainEvents",
  props: ["mainEvents"],

  data: () => ({
    group: 0,
  }),

  components: { MainEventCard },

  methods: {
    prev() {
      if (this.group === 0) {
        return;
      }

      this.group = this.group - 2;
    },

    next() {
      this.group = this.group + 2;
    },
  },
};
</script>

<style>
.main-events .v-slide-group__content {
  justify-content: center;
}
</style>
